import { render, staticRenderFns } from "./StageView.vue?vue&type=template&id=10a3fdd0"
import script from "./StageView.vue?vue&type=script&lang=js"
export * from "./StageView.vue?vue&type=script&lang=js"
import style0 from "./StageView.vue?vue&type=style&index=0&id=10a3fdd0&prod&lang=scss"
import style1 from "./StageView.vue?vue&type=style&index=1&id=10a3fdd0&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports